import React, { useState } from "react";
import "./header.scss";
import { Grid, Container, Box } from "@mui/material";
import FooterNew from "../../layout/footer/Footer-new";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

function HeaderNew() {
const [menuOpen, setMenuOpen] = useState(false);

  // ======================================================
  // HEADER NAV ITEMS
  // Desktop + Mobile dono isi array se handle honge
  // ======================================================
  const navItems = [
    {
      label: "Home",
      href: "/",
    },
    {
      label: "About us",
      href: "about-us",
    },
    {
      label: "Lockers",
      href: "locker",
    },
    {
      label: "Contact us",
      href: "contact-us",
    },
  ];

  const handleNavClick = () => {
    setMenuOpen(false);
  };
  return (
     <header className="mainHeader">
      <Container maxWidth="lg">
        <Grid
          container
          alignItems="center"
          className="headerContainer"
        >
          {/* ======================================================
              LOGO
          ====================================================== */}
          <Grid size={{ xs: 6, lg: 3 }}>
            <a href="/" className="mainLogo">
              <img
                src="/assets/home/logo.png"
                className="img-fluid"
                alt="Mandir Wiki"
              />
            </a>
          </Grid>

          {/* ======================================================
              DESKTOP NAV
          ====================================================== */}
          <Grid size={{ xs: 6, lg: 9 }}>
            <div className="headerRight">
              <div className="navLinks">

                {navItems.map((item) => (
                  <a
                    key={item.label}
                    href={item.href}
                    onClick={handleNavClick}
                  >
                    {item.label}
                  </a>
                ))}

                {/* Download App */}
                <a
                  href="https://play.google.com/store/apps/details?id=com.mandir.wiki&pcampaignid=web_share"
                  className="downloadBtn"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  DOWNLOAD THE APP
                </a>
              </div>

              {/* Mobile Menu Button */}
              <button
                type="button"
                className={`menuToggle ${menuOpen ? "active" : ""}`}
                onClick={() => setMenuOpen(true)}
                aria-label="Open menu"
              >
                <span></span>
                <span></span>
                <span></span>
              </button>
            </div>
          </Grid>
        </Grid>
      </Container>

      {/* ======================================================
          MOBILE OVERLAY
      ====================================================== */}
      <div
        className={`offcanvasOverlay ${menuOpen ? "show" : ""}`}
        onClick={() => setMenuOpen(false)}
      ></div>

      {/* ======================================================
          MOBILE OFFCANVAS
      ====================================================== */}
      <div className={`mobileOffcanvas ${menuOpen ? "open" : ""}`}>
        <div className="offcanvasHeader">

          {/* Mobile Logo */}
          <a href="/" className="offcanvasLogo">
            <img
              src="/assets/home/logo.png"
              alt="Mandir Wiki"
            />
          </a>

          {/* Close Button */}
          <button
            type="button"
            className="offcanvasClose"
            onClick={() => setMenuOpen(false)}
            aria-label="Close menu"
          >
            <span></span>
            <span></span>
          </button>
        </div>

        {/* ======================================================
            MOBILE NAV
            SAME navItems ARRAY
        ====================================================== */}
        <nav className="mobileNavLinks">

          {navItems.map((item) => (
            <a
              key={item.label}
              href={item.href}
              onClick={handleNavClick}
            >
              {item.label}
            </a>
          ))}

          {/* Download App */}
          <a
            href="https://play.google.com/store/apps/details?id=com.mandir.wiki&pcampaignid=web_share"
            className="downloadBtn"
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleNavClick}
          >
            DOWNLOAD THE APP
          </a>
        </nav>
      </div>
    </header>
  );
}

export default HeaderNew;
